console.log('work');
jQuery(document).ready(($) => {
  $(document).on('click', '.plus', function(e) {
    let $input = $(this).prev('input.quantity__input');
    let val = parseInt($input.val());
    $input.val( val+1 ).trigger('change');
    $input.attr("data_qty",val+1);
  });
  $(document).on('click', '.minus',  function(e) {
    let $input = $(this).next('input.quantity__input');
    var val = parseInt($input.val());
    if (val > 0) {
      $input.val( val-1 ).trigger('change');
      $input.attr("data_qty",val - 1);
    } 
  }); 
});


jQuery(document).ready(($) => {
  $(document).on('click', '.addon-button',  function(e) {
    fetch('/?section_id=addon-product')
    .then(response => response.text())
    .then((data) =>{ 

      //   modal open
      let $quickShopModalContent = $('[data-modal-content]');
      $("body").addClass('modal-loaded modal-visible');
      $(".modal-close").html('No thanks… close this.');
      $quickShopModalContent.parents('.modal').addClass('addon_modal');
      $quickShopModalContent.html(data); // Inserting product wrapper into modal
      //   qty    
      var model_qty_val = parseInt( $('.addon_modal .quantity__input').val());
      $(document).on('click', '.addon_modal .plus', function(e) {
        let $input = $(this).prev('.addon_modal input.quantity__input');
        $input.val( model_qty_val + 1 ).trigger('change');
        model_qty_val = model_qty_val + 1;
      });
      $(document).on('click', '.addon_modal .minus',  function(e) {
        let $input = $(this).next('.addon_modal input.quantity__input');
        if (model_qty_val > 0) {
          $input.val( model_qty_val - 1 ).trigger('change');
          model_qty_val = model_qty_val - 1;
        } 
      }); 
      //  close modal     
      $(document).on('click', '.addon_modal .modal-close', function(e) {
        $("body").removeClass('modal-loaded modal-visible');
        $quickShopModalContent.html('');
      });
      //  add to cart
      $('.addon_modal .extra_addon').show();
      $(document).on('click', '.addon_modal .upsell_product_but', function(e) {
        console.log(model_qty_val);
        var header = document.querySelector('[data-site-header]');
        var flyOutSelector = '[data-atc-banner]';
        var atcTemplate = document.querySelector(`[data-templates] ${flyOutSelector}`);
        const flyOut = atcTemplate.cloneNode(true);
       
        
        console.log(e.target);
        var id = e.target.getAttribute('data-variant-id');
        e.target.classList.add('processing');
        e.target.setAttribute('disabled', 'disabled');
        var dataqty = $('.extra_addon_item .quantity__input').attr('data_qty');
        let formData = {
          'items': [{ 'id': id, 'quantity': model_qty_val }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then((data) => {

          //               console.log(data);
          var item_originalPrice = data.items[0].original_price;
          [...data.items].forEach((item) =>{ 
            if (item.featured_image.url) {
              const imageUrl = item.featured_image.url;
              const productImage = flyOut.querySelector('[data-atc-banner-product-image]');
              productImage.innerHTML = `<img src="${imageUrl}" alt="${item.featured_image.alt}">`;         
            }   
            item_originalPrice = item.original_price;
          });
          const productTitle = flyOut.querySelector('[data-atc-banner-product-title]');
          productTitle.innerHTML = data.items[0].product_title;
          const productOptions = flyOut.querySelector('[data-atc-banner-product-options]');
          if (data.items[0].variant_options[0] !== 'Title' && data.items[0].variant_options[0] !== 'Default Title') {
            productOptions.innerHTML = data.items[0].variant_options.join(', ');
          }else{
            productOptions.innerHTML = "Default Title";
          }
          const productPriceQuantity = flyOut.querySelector('[data-atc-banner-product-price-quantity]');
          productPriceQuantity.innerHTML = `${model_qty_val} × `;
          const productPriceValue = flyOut.querySelector('[data-atc-banner-product-price-value]');
          productPriceValue.innerHTML = Shopify.formatMoney(item_originalPrice, window.Theme.money_format);

          //         cart render
          fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            //                 console.log(cart);
            document.querySelector('[data-header-cart-count]').dataset.headerCartCount = cart.item_count;
            const flyOutsubTotal = flyOut.querySelector('[data-atc-banner-cart-subtotal]');
            flyOutsubTotal.innerHTML = Shopify.formatMoney(cart.total_price,window.Theme.money_format);
            const flyOutitemCount = flyOut.querySelector('[data-atc-banner-cart-button] span');
            flyOutitemCount.innerHTML = cart.item_count; 
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
                   console.log('finally end');
          e.target.classList.remove('processing');
          e.target.removeAttribute('disabled', 'disabled');
        });
        //         cart render end
        $('.addon_button_response').html(flyOut);
        
        $('.addon_button_response').children('.atc-banner--container').attr('data-animation-state','open');
        flyOut.querySelector('[data-atc-banner-product-discounts]').style.display = "none";
        console.log(flyOut);
        
        $(document).on('click', '.atc-banner--close', function(e) {
          console.log(e);
          $(this).parents('.atc-banner--container').attr('data-animation-state',"closed");
        });
       
        
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
               $("body").removeClass('modal-loaded modal-visible');
      $quickShopModalContent.html('');
               console.log('finally end add to cart');
      
        

    });
        
        
      });
    });

  }); 
});